module.exports = __webpack_public_path__ + "static/media/kulcsSoft_color.70a28a3c.svg";